export const understandCreditNote = {
  title: 'Forstå din kreditnota fra YouSee',
  description:
    'Få hjælp til at forstå hvad en kreditnota består af, og hvad de forskellige ord og begreber betyder.',
  url: 'https://yousee.dk/hjaelp/artikler/forsta-din-kreditnota',
};

export const payWithoutLogin = {
  title: 'Betal din regning uden login',
  description: 'Se hvordan du betaler din regning, uden at skulle logge ind.',
  url: 'https://yousee.dk/hjaelp/artikler/betaling-af-din-regning',
};

export const goodAdvice = {
  title: 'Gode råd til regning og betaling i Mit YouSee',
  description: 'Find oplysninger om dine regning og betalinger i Mit YouSee.',
  url: 'https://yousee.dk/hjaelp/artikler/6-tips-om-din-regning-i-mit-yousee',
};

export const labels = {
  default: [understandCreditNote, payWithoutLogin, goodAdvice],
} as const;
